/* ============================================================
   WORDS お問い合わせフォーム（sections/main-contact.liquid 用）
   design_handoff_v6/CONTACT_FORM.md 5章「挙動」のとおり実装。
   ライブラリなし・素のJS。
   ============================================================ */
(function () {
  'use strict';

  /* 画面に出す文言は snippets/words-t-g7.liquid（window.WORDS_T.contact_js）。無ければ日本語 */
  function T_contact_js(k, ja) { var t = window.WORDS_T && window.WORDS_T.contact_js; return (t && t[k]) || ja; }

  /* 完了画面（7b）：Shopifyはレイアウト側で送信結果を判定できないため、
     .cf-done が描画されているときだけJSでtitleとnoindexを差し替える。 */
  if (document.querySelector('.cf-done')) {
    document.title = T_contact_js('done_title', 'お問い合わせを受け付けました | WORDS');
    var robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);
  }

  var form = document.getElementById('ContactForm');
  if (!form) return;

  /* 例文のルール（2026-09-15 変更）
     ・「フリーとXL、どちらが合いますか？」のような、一点ずつの見立てを前提にした例文は出さない
       （一件ずつのサイズ相談には対応していないため）
     ・返品はサイズ違いでは受け付けていないので、不備を前提にした例文にする
     ・「ご注文・配送について」「店舗について」の種別は廃止した（liquid 側の cf_type_defs と揃えること） */
  var TYPE_PLACEHOLDERS = {
    product: T_contact_js('ph_free', 'ご自由にご記入ください。'),
    'return': T_contact_js('ph_return', '例：届いた商品に不備がありました。注文 #1234 の返品をお願いできますか。'),
    wholesale: T_contact_js('ph_wholesale', '例：セレクトショップを運営しています。卸条件とカタログをご案内ください。'),
    other: T_contact_js('ph_free', 'ご自由にご記入ください。')
  };

  var typeInputs = form.querySelectorAll('.cf-type-input');
  var condFields = form.querySelectorAll('.cf-cond');
  var bodyField = document.getElementById('cf-body');
  var bodyCount = document.getElementById('cf-body-count');
  var wholesaleHint = form.querySelector('[data-hint="wholesale"]');
  var submitBtn = form.querySelector('.cf-submit');
  var typeErrEl = document.getElementById('cf-type-err');

  function applyType(key) {
    for (var i = 0; i < condFields.length; i++) {
      var el = condFields[i];
      var keys = (el.getAttribute('data-show') || '').split(',');
      var show = keys.indexOf(key) !== -1;
      el.hidden = !show;
      var field = el.querySelector('input, textarea, select');
      if (field) field.disabled = !show;
    }
    if (bodyField && TYPE_PLACEHOLDERS[key]) {
      bodyField.placeholder = TYPE_PLACEHOLDERS[key];
    }
    if (wholesaleHint) {
      wholesaleHint.hidden = key !== 'wholesale';
    }
  }

  for (var i = 0; i < typeInputs.length; i++) {
    typeInputs[i].addEventListener('change', function () {
      applyType(this.getAttribute('data-key'));
      if (typeErrEl) typeErrEl.textContent = '';
    });
  }

  function updateCount() {
    if (!bodyField || !bodyCount) return;
    var len = bodyField.value.length;
    if (len > 1000) {
      bodyField.value = bodyField.value.slice(0, 1000);
      len = 1000;
    }
    bodyCount.textContent = len + ' / 1000';
  }
  if (bodyField) {
    updateCount();
    bodyField.addEventListener('input', function () {
      updateCount();
      clearFieldError(bodyField);
    });
  }

  function setFieldError(field, message) {
    field.classList.add('is-error');
    var errId = field.getAttribute('aria-describedby');
    if (!errId) return;
    var ids = errId.split(' ');
    for (var j = 0; j < ids.length; j++) {
      var el = document.getElementById(ids[j]);
      if (el && el.classList.contains('cf-err')) el.textContent = message;
    }
  }
  function clearFieldError(field) {
    if (!field) return;
    field.classList.remove('is-error');
    var errId = field.getAttribute('aria-describedby');
    if (!errId) return;
    var ids = errId.split(' ');
    for (var j = 0; j < ids.length; j++) {
      var el = document.getElementById(ids[j]);
      if (el && el.classList.contains('cf-err')) el.textContent = '';
    }
  }

  var trackedFields = form.querySelectorAll('.cf-input, .cf-textarea');
  for (var k = 0; k < trackedFields.length; k++) {
    trackedFields[k].addEventListener('input', function () { clearFieldError(this); });
  }

  var consentInput = document.getElementById('cf-consent');
  if (consentInput) {
    consentInput.addEventListener('change', function () {
      var consentErr = document.getElementById('cf-consent-err');
      if (consentErr) consentErr.textContent = '';
      var wrap = consentInput.closest('.cf-consent');
      if (wrap) wrap.classList.remove('is-error');
    });
  }

  form.addEventListener('submit', function (e) {
    var firstInvalid = null;

    var typeChecked = form.querySelector('.cf-type-input:checked');
    if (!typeChecked) {
      if (typeErrEl) typeErrEl.textContent = T_contact_js('err_type', 'お問い合わせの種類を選択してください。');
      firstInvalid = firstInvalid || typeInputs[0] || null;
    }

    var nameInput = document.getElementById('cf-name');
    var emailInput = document.getElementById('cf-email');
    var bodyInput = document.getElementById('cf-body');

    if (nameInput && !nameInput.checkValidity()) {
      setFieldError(nameInput, T_contact_js('err_name', 'お名前を入力してください。'));
      firstInvalid = firstInvalid || nameInput;
    }
    if (emailInput && !emailInput.checkValidity()) {
      var msg = emailInput.validity.valueMissing
        ? T_contact_js('err_email_missing', 'メールアドレスを入力してください。')
        : T_contact_js('err_email_format', 'メールアドレスの形式が正しくありません。');
      setFieldError(emailInput, msg);
      firstInvalid = firstInvalid || emailInput;
    }
    if (bodyInput && !bodyInput.checkValidity()) {
      setFieldError(bodyInput, T_contact_js('err_body', 'お問い合わせ内容を入力してください。'));
      firstInvalid = firstInvalid || bodyInput;
    }

    if (consentInput && !consentInput.checkValidity()) {
      var consentErr = document.getElementById('cf-consent-err');
      if (consentErr) consentErr.textContent = T_contact_js('err_consent', 'プライバシーポリシーへの同意が必要です。');
      var consentWrap = consentInput.closest('.cf-consent');
      if (consentWrap) consentWrap.classList.add('is-error');
      firstInvalid = firstInvalid || consentInput;
    }

    if (firstInvalid) {
      e.preventDefault();
      if (typeof firstInvalid.scrollIntoView === 'function') {
        firstInvalid.scrollIntoView({ block: 'center' });
      }
      if (typeof firstInvalid.focus === 'function') firstInvalid.focus();
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = submitBtn.getAttribute('data-sending-label') || T_contact_js('sending', '送信中…');
    }
  });

  /* ?product=<handle> があれば「商品・サイズについて」を初期選択し、
     対象商品欄に商品名を自動入力する。 */
  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('product');
  if (productHandle) {
    var productType = form.querySelector('.cf-type-input[data-key="product"]');
    if (productType) {
      productType.checked = true;
      applyType('product');
    }
    var productField = form.querySelector('[name="contact[対象商品]"]');
    if (productField) {
      fetch('/products/' + encodeURIComponent(productHandle) + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && data.title) productField.value = data.title;
        })
        .catch(function () {});
    }
  }

  /* ?type=wholesale などで種別を初期選択する（法人ページ・メニューの「法人のお問い合わせ」から来たとき）。2026-10-20 */
  var typeKey = (params.get('type') || '').replace(/[^a-z]/g, '');
  if (typeKey && !productHandle) {
    var typeInput = form.querySelector('.cf-type-input[data-key="' + typeKey + '"]');
    if (typeInput) {
      typeInput.checked = true;
      applyType(typeKey);
    }
  }
})();
